module.exports = __webpack_public_path__ + "img/ni.baafd7d7.svg";